import { BrowserRouter } from "react-router-dom";
import LogoutOverlay from "components/Layout/TopBar/ModalLogoutOverlay";
import RoutesComponent from "./routes";

import "./index.css";

const App = () => {
  return (
    <>
      <LogoutOverlay />
      <BrowserRouter>
        <RoutesComponent />
      </BrowserRouter>
    </>
  );
};

export default App;
